<template>
  <v-container class="input-text-size">
    <CRUDCriteria
      :showReset="false"
      :showSearch="false"
      :showAdditionalActions="false"
      @loadCRUDList="handleLoadTaxPayments"
    >
      <template v-slot:criteriaRows>
        <div>
          <v-row dense class="mt-1">
            <v-col cols="2" class="pt-0 pb-0">
              <CommonDropDowns
                :isItTaxYear="true"
                @change="dataFromCommonDropDowns"
                :criteriaState="criteriaState"
              />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <CommonDropDowns
                :isItTaxFee="true"
                @change="dataFromCommonDropDowns"
              />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <v-text-field
                class="input-text-size"
                label="fee Amount"
                v-model.number="criteriaState.feeAmount"
                @input="searchByCriteria"
              >
              </v-text-field>
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <ClarionDateControl
                class="input-text-size"
                :isIsoDate="false"
                :isToggle="false"
                v-model="criteriaState.effectiveDate"
                label="Effective Date"
                @change="searchByCriteria"
              />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <v-text-field
                class="input-text-size"
                label="Wildcard search (tax Id)"
                v-uppercase=globalSettingItem.conEverythingToCaps
                v-model="criteriaState.wildcard"
                @input="wildcardSearchDelayed"
                autocomplete="off"
              >
              </v-text-field>
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <v-checkbox
                label="Include Paid Fees"
                dense
                class="mt-3"
                v-model="criteriaState.isPaid"
                @change="updateSelectOption"
              ></v-checkbox>
            </v-col>
          </v-row>
        </div>
      </template>
    </CRUDCriteria>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :canEdit="false"
      :canSave="true"
      :headers="headers"
      :showSelect="true"
      :displayTopPagination="false"
      :showDate="false"
      :showTotal="false"
      :selectedItems="selectedItems"
      :defaultSortBy="defaultSortBy"
      tableWrapperDynamicClassname="elevation-3 ma-3 pa-3 taxroll-table-wrapper"
      tableDynamicClassname="taxroll-custom-table"
      tableDynamicHeight="250"
      @loadCRUDList="handleLoadTaxPayments"
      @emitSelectedItem="emitSelectedItem"
      @upsertItem="updateTaxfeesRecods"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      hideCheckbox="isPaid"
      :baseCrudKey="baseCrudKey"
      dialogDynamicWidth="24vw"
    >
    <template v-slot:[`editedItem`]="{ }">
    <FeeManagmentEditDialog :baseCrudKey="baseCrudKey" />
    </template>
    </CRUDList>
    <v-row dense class="mr-3 ml-7">
      <v-col cols="2">
        <v-btn
          class="mt-2"
          small
          rounded
          color="primary"
          @click="deleteTaxFees"
        >
        Delete Selected Fees
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="mt-2"
          small
          rounded
          color="primary"
          @click="modifyTaxFeeDialog"
        >
          Modify Selected Fees
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapGetters,
  mapState,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
// import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import { FeeManagementHeaders } from './utils/trWorkFileHeaders';
import {
  amountToNumber,
  defaultGridLoading,
  manageGridLoading,
} from '../../../util/shared/vue-global';
import { toIsoDate } from '../../../util/shared/tmc-global';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import FeeManagmentEditDialog from './FeeManagmentEditDialog.vue';
import { SEARCH_DEBOUNCE_TIMER } from '../common-utils/constants';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'feeManagmentComponent',
  mixins: [GlobalToCaps],
  data() {
    return {
      headers: FeeManagementHeaders,
      gridLoading: defaultGridLoading(),
      baseCrudKey: 'taxRollFeesTable',
      isModifyFeeDetails: false,
      isDisable: true,
    };
  },
  components: {
    CRUDCriteria,
    CRUDList,
    ClarionDateControl,
    CommonDropDowns,
    FeeManagmentEditDialog,
  },
  created() {
    const effectiveDateValue = toIsoDate(this.todaysDate);
    this.effectiveDate = effectiveDateValue;
    this.initCriteria();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'isVisible']),
    ...mapState({
      storedSelectedItems: (state) => state.tax.taxFee.selectedItems || [],
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    selectedItems: {
      get() {
        return this.storedSelectedItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    rowItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'paymentDate',
          direction: 'desc',
        },
      ];
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
  },
  methods: {
    ...mapActions('tax/taxFee', ['loadTaxRollFeesTable', 'bulkDeleteTaxFees', 'bulkUpdateTaxFees']),
    manageGridLoading,
    ...mapMutations('base/crud', ['setCriteria', 'setIsVisible']),
    ...mapMutations('tax/taxFee', ['setSelectedItems']),
    initCriteria() {
      // for now commenting this
      // this.criteriaState.isPaid = false;
      this.criteriaState.taxYear = 0;
      // this.criteriaState.fiscalYear = toFiscalYear(new Date(this.todaysDate));
    },
    modifyTaxFeeDialog() {
      const selectedItems = this.storedSelectedItems;
      const items = selectedItems.filter((el) => typeof el === 'object');
      if (items.length === 0) {
        window.confirm('Please select Item first');
        return true;
      }
      this.setIsVisible([this.baseCrudKey, true]);
      return true;
    },
    deleteTransaction(upsert) {
      const { baseCrudKey } = this;
      this.bulkDeleteTaxFees({ upsert, baseCrudKey }).then(() => {
        this.selectedItems = [];
        this.handleLoadTaxPayments();
      }).catch((e) => {
        console.warn(e);
        this.selectedItems = [];
      });
    },
    async deleteTaxFees() {
      const selectedItems = this.storedSelectedItems;
      const items = selectedItems.filter((el) => typeof el === 'object');
      if (items.length === 0) {
        window.confirm('Please select Item first');
        return true;
      }
      if (window.confirm(`CAREFUL! Are you sure you want to DELETE ${this.selectedItems.length} record/s?`)) {
        const _ids = [];
        for (const value of items) {
          if (!value.isPaid) {
            _ids.push(value._id);
          }
        }
        const upsert = {
          _ids,
        };

        this.deleteTransaction(upsert);
      }
      this.selectedItems = [];
      return {};
    },
    updateTransaction(upsert) {
      const { baseCrudKey } = this;
      this.bulkUpdateTaxFees({ upsert, baseCrudKey }).then(() => {
        this.selectedItems = [];
        this.handleLoadTaxPayments();
      }).catch((e) => {
        console.warn(e);
        this.selectedItems = [];
      });
    },
    async updateTaxfeesRecods(item) {
      const selectedItems = this.storedSelectedItems;
      const items = selectedItems.filter((el) => typeof el === 'object');
      if (items.length === 0) {
        window.confirm('Please select Item first');
        return true;
      }
      if (window.confirm(`CAREFUL! Are you sure you want to UPDATE ${this.selectedItems.length} record/s?`)) {
        const _ids = [];
        const taxFeerecods = [];
        for (const value of items) {
          if (!value.isPaid) {
            _ids.push(value._id);
            taxFeerecods.push({
              taxYear: value.taxYear,
              taxId: value.taxId,
              feeAmount: value.feeAmount,
            });
          }
        }
        let effDate = null;
        if (item.newEffectiveDate) effDate = toIsoDate(item.newEffectiveDate);
        const upsert = {
          _ids,
          newFeeNumber: amountToNumber(item.newFeeNumber),
          newFeeAmount: amountToNumber(item.newFeeAmount),
          newEffectiveDate: effDate,
          taxFeerecods,
        };
        this.updateTransaction(upsert);
      }
      return {};
    },
    handleLoadTaxPayments() {
      manageGridLoading(this, true, 'Searching...');
      const { baseCrudKey } = this;
      const criteria = {
        // taxYear: 2020,
        ...this.criteriaState,
      };
      this.loadTaxRollFeesTable({
        criteria,
        baseCrudKey,
        postProcessTrans: this.postProccessData,
      })
        .then(() => {
          this.setDefaultSelectedItems();
        })
        .finally(() => {
          manageGridLoading(this, false);
        });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    updateSelectOption() {
      this.searchByCriteria();
      if (this.criteriaState.isPaid) {
        this.isDisable = false;
      } else {
        this.isDisable = true;
      }
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(
        this.criteriaState,
      );
      this.criteriaState = { ...returnCriteria };
      if (this.criteriaState.effectiveDate) {
        this.criteriaState.effectiveDate = toIsoDate(this.criteriaState.effectiveDate);
      }
      // this.$emit('loadCRUDList');
      this.handleLoadTaxPayments();
    },
    wildcardSearchDelayed() {
      // cancel pending call
      clearTimeout(this.delayTimerId);
      // delay new call
      this.delayTimerId = setTimeout(async () => {
        const criteriaArgs = { searchMode: 'wildcard' };
        this.setDefaultSelectedItems(criteriaArgs);
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
  },
};
</script>
